<template>
    <div class="p-compare-reserve__percentage">
        <div class="p-compare-reserve__slider">
            <vue-slider v-model="range"
                        ref="slider" :min="-1" :max="1"
                        :interval="0.1"
                        :real-time="true"
                        :clickable="true"
                        :bg-style="backgroundStyle"
                        :process-style="{'backgroundColor' : '#a6a6a6'}"
                        :tooltip-style="[
                            {
                            'backgroundColor': '#85f7d9',
                            'borderColor': '#85f7d9',
                            'color': 'black',
                            'padding': '8px 12px 5px',
                            }, 
                            {
                            'backgroundColor': '#e68bb4',
                            'borderColor': '#e68bb4',
                            'color': 'black',
                            'padding': '8px 12px 5px',
                            }
                        ]"
                        :label-style="{'color' : '#fff'}"
                        :formatter="rangeDisplay"
            ></vue-slider>
        </div>
        <p class="u-text-center">
            Set your percentage over/under range.
        </p>
    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component';

    export default {
        name: "slider",
        components: {
            VueSlider
        },
        computed: {
            backgroundStyle() {
                let min = (100 + (Math.min(...this.$store.getters['reserves/compare/range']) * 100)) / 2;
                let max = (100 + (Math.max(...this.$store.getters['reserves/compare/range']) * 100)) / 2;

                return {
                    // I believe if we need vendor prefixes, they can go here.
                    'background': 'linear-gradient(to right, #85f7d9 ' + min + '%, #a6a6a6 ' + min + '%, #a6a6a6 ' + max + '%, #e68bb4 ' + max + '%)'
                };
            },
            range: {
                get() {
                    return this.$store.getters['reserves/compare/range'];
                },
                set(value) {
                    return this.$store.dispatch('reserves/compare/update', {key: 'range', value});
                }
            },
            rangeDisplay() {
                return (value) => Math.round(value * 100) + '%';
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Slider.vue?3c758f04